/* ========================================
   More link
======================================== */

document.querySelectorAll('.more-link').forEach((element) => {
  const maxLines = Number(element.dataset.max) || 4;

  const styles = window.getComputedStyle(element);

  const lineHeight =
    parseFloat(styles.lineHeight) ||
    parseFloat(styles.fontSize) * 1.5;

  const collapsedHeight = lineHeight * maxLines;
  const fullHeight = element.scrollHeight;

  if (fullHeight <= collapsedHeight) return;

  element.style.overflow = 'hidden';
  element.style.height = `${collapsedHeight}px`;
  element.style.marginBottom = '0';
  element.style.transition = 'height 0.15s ease';

  const buttonWrapper = document.createElement('div');
  buttonWrapper.className = 'more-link-after';

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'more-link-button';
  button.textContent = '･･･続きを読む';

  buttonWrapper.appendChild(button);
  element.after(buttonWrapper);

  let isOpen = false;

  button.addEventListener('click', () => {
    isOpen = !isOpen;

    if (isOpen) {
      element.style.height = `${element.scrollHeight}px`;
      button.textContent = '閉じる';
    } else {
      element.style.height = `${collapsedHeight}px`;
      button.textContent = '･･･続きを読む';
    }
  });
});


/* ========================================
   Category more button
======================================== */

document.querySelectorAll('.col-cat').forEach((container) => {
  const list = container.querySelector('.col-cat-more');
  const button = container.querySelector('.cat-more-btn');

  if (!list || !button) return;

  const items = [...list.querySelectorAll(':scope > a')];
  const label = button.querySelector('.label');
  const icon = button.querySelector('.icon');

  let isExpanded = false;

  const getLimit = () => {
    return window.innerWidth < 768 ? 8 : 12;
  };

  const updateItems = () => {
    const limit = getLimit();

    if (items.length <= limit) {
      items.forEach((item) => {
        item.style.display = '';
        item.style.opacity = '';
        item.style.transform = '';
      });

      button.style.display = 'none';
      return;
    }

    button.style.display = '';

    items.forEach((item, index) => {
      if (isExpanded || index < limit) {
        item.style.display = '';
        item.style.opacity = '1';
        item.style.transform = 'translateY(0)';
      } else {
        item.style.display = 'none';
        item.style.opacity = '0';
        item.style.transform = 'translateY(-10px)';
      }
    });
  };

  button.addEventListener('click', () => {
    const limit = getLimit();

    isExpanded = !isExpanded;

    if (isExpanded) {
      items.forEach((item, index) => {
        if (index < limit) return;

        item.style.display = '';
        item.style.opacity = '0';
        item.style.transform = 'translateY(-10px)';

        requestAnimationFrame(() => {
          item.style.transition =
            'opacity 0.2s ease, transform 0.2s ease';

          item.style.opacity = '1';
          item.style.transform = 'translateY(0)';
        });
      });

      label.textContent = '閉じる';
      icon.textContent = '';

    } else {
      items.forEach((item, index) => {
        if (index < limit) return;

        item.style.transition =
          'opacity 0.3s ease, transform 0.3s ease';

        item.style.opacity = '0';
        item.style.transform = 'translateY(-10px)';

        setTimeout(() => {
          item.style.display = 'none';
        }, 300);
      });

      label.textContent = 'もっと見る';
      icon.textContent = '＋';
    }
  });

  window.addEventListener('resize', updateItems);

  updateItems();
});